export default __webpack_public_path__ + "images/BH.1bd33d2.png";